module.exports = __webpack_public_path__ + "assets/img/Future_Bihouix.f285f4b3-ps.jpg";